import { Label } from '@/components/ui/label';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';
import { Smartphone, Check } from 'lucide-react';
import { cn } from '@/lib/utils';

type ChipOperator = 'tim' | 'claro' | 'vivo' | 'm2m' | null;

interface ChipOperatorSelectorProps {
  value: ChipOperator;
  onChange: (operator: ChipOperator) => void;
}

const operators = [
  {
    id: 'tim' as const,
    name: 'TIM',
    color: 'bg-blue-600',
    iccidPrefix: '8955'
  },
  {
    id: 'claro' as const,
    name: 'Claro',
    color: 'bg-red-600',
    iccidPrefix: '8931'
  },
  {
    id: 'vivo' as const,
    name: 'Vivo',
    color: 'bg-purple-600',
    iccidPrefix: '8932'
  },
  {
    id: 'm2m' as const,
    name: 'M2M',
    color: 'bg-gray-600',
    iccidPrefix: null
  }
];

export function ChipOperatorSelector({ value, onChange }: ChipOperatorSelectorProps) {
  return (
    <div className="space-y-3">
      <Label>Operadora do Chip *</Label>
      <RadioGroup value={value || ''} onValueChange={onChange}>
        <div className="grid grid-cols-2 gap-3">
          {operators.map((op) => (
            <label
              key={op.id}
              className={cn(
                "flex items-center gap-3 p-4 rounded-lg border-2 cursor-pointer transition-all",
                value === op.id 
                  ? "border-primary bg-primary/5" 
                  : "border-border hover:border-primary/50"
              )}
            >
              <RadioGroupItem value={op.id} id={op.id} className="sr-only" />
              
              {/* Logo/Icon */}
              <div className={cn("w-12 h-12 rounded-lg flex items-center justify-center text-white", op.color)}>
                {op.id === 'm2m' ? (
                  <Smartphone className="w-6 h-6" />
                ) : (
                  <span className="font-bold text-sm">{op.name}</span>
                )}
              </div>
              
              {/* Info */}
              <div className="flex-1">
                <div className="font-semibold">{op.name}</div>
                {op.iccidPrefix && (
                  <div className="text-xs text-muted-foreground">
                    ICCID: {op.iccidPrefix}...
                  </div>
                )}
              </div>
              
              {/* Checkmark */}
              {value === op.id && (
                <Check className="w-5 h-5 text-primary" />
              )}
            </label>
          ))}
        </div>
      </RadioGroup>
    </div>
  );
}
